import { useEffect } from 'react';
import { useAuthStore } from '../../store/authStore';

interface CrispChatProps {
  websiteId?: string;
}

export const CrispChat: React.FC<CrispChatProps> = ({ 
  websiteId = '8fe0ea0a-18cc-45ea-827b-a042228cdb14' 
}) => {
  const { user } = useAuthStore();

  useEffect(() => {
    // Only initialize if not already initialized in index.html
    if (!window.$crisp) {
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = websiteId;

      // Load the Crisp script
      const script = document.createElement('script');
      script.src = 'https://client.crisp.chat/l.js';
      script.async = true;
      document.head.appendChild(script);
    }

    // Listen for Crisp ready event to ensure it's fully loaded
    const handleCrispReady = () => {
      if (user && window.$crisp) {
        try {
          console.log('🎯 Configuring Crisp with user data:', {
            email: user.email,
            name: user.name || user.firstName
          });
          
          // Set user email (prevents email prompt) - this is the most important
          if (user.email) {
            window.$crisp.push(['set', 'user:email', user.email]);
          }
          
          // Set user nickname with full name if available, fallback to firstName or email
          const displayName = user.name || user.firstName || user.email?.split('@')[0] || '';
          if (displayName) {
            window.$crisp.push(['set', 'user:nickname', displayName]);
          }
          
          // Set user avatar if available
          if (user.photoURL) {
            window.$crisp.push(['set', 'user:avatar', user.photoURL]);
          }
          
          console.log('✅ Crisp configured successfully - no email prompt should appear!');
        } catch (error) {
          console.error('❌ Error configuring Crisp:', error);
        }
      }
    };

    // Check if Crisp is already ready or wait for it
    if (window.$crisp && typeof window.$crisp.push === 'function') {
      // Crisp is ready, configure immediately
      handleCrispReady();
    } else {
      // Wait for Crisp to be ready
      const checkCrispReady = () => {
        if (window.$crisp && typeof window.$crisp.push === 'function') {
          handleCrispReady();
        } else {
          setTimeout(checkCrispReady, 500);
        }
      };
      checkCrispReady();
    }
  }, [user, websiteId]);

  // This component doesn't render anything visible
  return null;
};

// Add TypeScript declarations for Crisp
declare global {
  interface Window {
    $crisp: any[];
    CRISP_WEBSITE_ID: string;
  }
} 